import {applyMiddleware, createStore} from "redux"
import {createLogger} from "redux-logger"
import reducer from "./reducers"
import thunk from 'redux-thunk'
import Config from './config'


let store = null

if(Config.DEBUG){ 
    const logger = createLogger({
        duration: true,
        collapsed: true,
        predicate: (getState, action) => {
            switch( action.type){
                case 'AUDIO_TIME_UPDATE':
                case 'CHATROOM_SET_DELAY':
                    return false
                default:
                    return true
            }
        }
    })

    const middleware = applyMiddleware(logger, thunk)
    store = createStore(reducer, middleware)
}else{
    const middleware = applyMiddleware(thunk)
    store = createStore(reducer, middleware)
}

export default store



// WEBPACK FOOTER //
// ./src/store.js